import {getFirestore, Firestore} from "firebase/firestore";
import {FirebaseApp} from "firebase/app";

export default class FirestoreClient {
  private static instance: Firestore;
  private static firebaseApp: FirebaseApp;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  static initialize(firebaseApp: FirebaseApp): void {
    FirestoreClient.firebaseApp = firebaseApp;
  }

  static getInstance(): Firestore {
    if (!this.instance) {
      if (!FirestoreClient.firebaseApp)
        throw new Error("FirestoreClient must be initialized first");

      this.instance = getFirestore(FirestoreClient.firebaseApp);
    }

    return this.instance;
  }
}
